import axios from "../../../context/axiosConfig";
import { useState, useEffect } from "react";
import { usePaginationPrzekazy } from "../../../context/PaginationContextPrzekazy";
import { notification } from "antd";

const PrzekazyGetList = () => {
	const { pagination, setPagination } = usePaginationPrzekazy();
	const [data, setData] = useState([]);

	useEffect(() => {
		let active = true;
		setPagination(current => ({ ...current, loading: true }));
		const fetchData = async () => {
			try {
				const response = await axios.post("/przekazania/get/list", {
					pagination: pagination,
				}, { timeout: 20000 });
				if (active) {
					setData(response.data);
					if (pagination.current > 1 && pagination.current > Math.ceil(response.data.total / pagination.pagesize)) {
						setPagination(current => ({ ...current, current: 1 }));
					}
				}
			} catch (error) {
				if (active) {
					console.error("Failed to load Przekazy list", error?.response?.status || error?.code || "unknown error");
					notification.error({
						message: "Nie udało się załadować listy przekazów",
						description: "Sprawdź połączenie z serwerem i spróbuj ponownie.",
					});
				}
			} finally {
				if (active) {
					setPagination(current => ({ ...current, loading: false }));
				}
			}
		};
		fetchData();
		return () => {
			active = false;
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		pagination.current,
		pagination.pagesize,
		pagination.reload,
		pagination.generated,
		pagination.search,
	]);

	return data;
};

export default PrzekazyGetList;
